import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";

export interface IPricesTableCategoryItemsItem {
  itemName: IUProperty<string>;
  licenses: IUProperty<IPricesTableCategoryItemsItemLicense[]>;
}

export interface IPricesTableCategoryItemsItemLicense {
  contentType: IUProperty<LicenseContentTypeEnum>;
  licenseIndex: IUProperty<number>;
  text: IUProperty<string>;
}

export enum LicenseContentTypeEnum {
  Check = "Check",
  Text = "Text",
  None = "None",
}

@Component({
  selector: "app-prices-table-category-items",
  templateUrl: "./prices-table-category-items.component.html",
  styleUrls: ["./prices-table-category-items.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricesTableCategoryItemsComponent {
  @Input() items: IPricesTableCategoryItemsItem[];

  licenseContentTypeEnum = LicenseContentTypeEnum;
}
